import {isEqual} from '@shared/helpers/lang'
import {get} from '@shared/helpers/object'

import {WaitingStatus} from '@web/core/constants'

import {Enterable, Expelled, Expired, SubTicket, WaitQueue} from './interfaces'

/** 대기열 만료 타입 */
const TICKET_EXPIRED_REASON_TYPE = 'TICKET_EXPIRED'

/** 진입 가능여부, 추방여부, 만료 여부에 따라 waiting status 를 구한다. */
export function getWaitingStatus(waitingBooleans: [Enterable, Expelled, Expired]) {
    const isEqualWaitingStatus = isEqual(waitingBooleans)
    if (isEqualWaitingStatus([true, false, false])) {
        return WaitingStatus.ENTERABLE
    } else if (isEqualWaitingStatus([false, true, false])) {
        return WaitingStatus.EXPELLED
    } else if (isEqualWaitingStatus([false, false, true])) {
        return WaitingStatus.EXPIRED
    }
    return WaitingStatus.QUEUING
}

/** 대기열 만료 에러 여부 */
export function isExpiredTicketError(error: unknown): boolean {
    return get('validationFailure.reasonType', error) === TICKET_EXPIRED_REASON_TYPE
}

/** 대기열이 만료되었는지 여부 */
export function isWaitingEnd(subTicket: Maybe<SubTicket>, waitQueue: WaitQueue) {
    const waitNumber = subTicket?.waitNumber ?? waitQueue.lastWaitNumber
    return waitNumber <= waitQueue.lastEnterableWaitNumber
}
